// Centralized config for site-wide placeholders.
// Edit these values to update across the entire site.

export const CRAVY_CONFIG = {
  // 📅 Calendly link for "Book a 10-min call" CTA.
  // Replace this with your real Calendly URL once you've set up Calendly.
  // (Sign up free at https://calendly.com — create an event called "Cravy Intro Call")
  calendlyUrl: "https://calendly.com/cravyco/intro-call",

  // 💰 Refer-a-property bonus amount (shown on /refer page)
  // Edit to whatever amount you want to pay for a successful referral.
  referralBonus: 500,

  // 📞 Phone numbers + emails
  phones: {
    jayson: "(314) 913-8897",
    ted:    "(314) 705-8356",
  },
  emails: {
    jayson: "Jayson@cravyco.com",
    ted:    "Ted@cravyco.com",
  },
};
